import { FC, ReactNode } from 'react';
import emptyIcon from '@/assets/images/dashboard/request-history-empty.png';
import styles from './HistoryEmpty.module.sass';

interface HistoryEmptyProps {
  title: string;
  desc: string;
  children?: ReactNode;
}

const HistoryEmpty: FC<HistoryEmptyProps> = (props) => {
  const { title, desc, children } = props;

  return (
    <div className={styles.empty}>
      <img src={emptyIcon} alt="empty" className={styles.empty__icon} />
      <div className={styles.empty__title}>{title}</div>
      <div className={styles.empty__description}>{desc}</div>
      <div className={styles.empty__description}>{children}</div>
    </div>
  );
};

export default HistoryEmpty;
